import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import useUserPreference from "./useUserPreference.ts";
import useUserPreferenceDate from "./useUserPreferenceDate.ts";
import { useEffect, useRef } from "react";
import {
  FeatureName,
  useRootLoaderFeatureEnabled,
} from "../../../root/rootLoader.ts";

interface NewFeatureProps {
  preferenceKey: UserPreferenceKey;
  numDays: number;
  isFeatureLive: boolean;
}

export default function useTrackNewFeature({
  preferenceKey,
  numDays,
  isFeatureLive,
}: NewFeatureProps) {
  const [preferenceValue, updatePreferenceValue] =
    useUserPreference<boolean>(preferenceKey);
  const initialValueRef = useRef(preferenceValue);
  const shouldUseShortDurations = useRootLoaderFeatureEnabled(
    FeatureName.ShortNewFeatures
  );

  // Ref makes resets from the debug menu play nice
  // Once it's true it doesn't normally flip back to false
  useEffect(() => {
    if (isFeatureLive && !initialValueRef.current) {
      updatePreferenceValue(true);
    }
  }, [isFeatureLive, updatePreferenceValue]);

  const isPastDate = useUserPreferenceDate(
    preferenceKey,
    shouldUseShortDurations ? 1 : numDays
  );

  return isFeatureLive && !isPastDate;
}
